import { render, staticRenderFns } from "./CoursesUpdate.vue?vue&type=template&id=c64bb42c"
import script from "./CoursesUpdate.vue?vue&type=script&lang=js"
export * from "./CoursesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports